<template>
<div class="chapter">
<div class="inner_page">
<span epub:type="pagebreak" id="pg_v" title="v">
<p class="TIT" id="tit"><img alt="" class="img90" src="images/72918_ch00_5P.jpg"/></p>
</span>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?3c136c7d